// constants for icons in commonly used actions
export default {
    BARS: "bars",
    MENU_ELLIPSIS: "ellipsis-vertical",
    MENU_DOTS: "ellipsis-vertical",
    MENU_BARS: "bars",
    DRAG_HANDLE: "grip-lines",
    SPINNER: "spinner",
    CHEVRON_UP: "chevron-up",
    CHEVRON_DOWN: "chevron-down",
    UPLOAD: "upload",
    EXPAND: "chevron-down",
    TODAY: "calendar-day",
    CLOSE: "times",
    MOON: "moon-stars",
    YOUTUBE: 'youtube',
    INFO: 'info-circle',
    INFO_SQUARE: 'info-square',
    CLOCK: "clock",
    DOLLAR: 'money-bill-wave',
    DOT: 'circle-dot',
    STAR: 'star',

    // actions
    EXPORT: "download", //"download",
    FILTER: "filter",
    CHART_AREA: "chart-area",
    FILTER_CLEAR: "times",
    HELP_GLOBAL: "question-circle",
    BACK: "arrow-left-long",
    DELETE: "trash-alt",
    CLEAR: "backspace",
    PRINT: "print",
    COPY: "copy",
    VIEW: "eye",
    EDIT: "pencil",
    BLOCK: "ban",
    UNBLOCK: "unlock", 
    DOWNLOAD: "download", //"download",
    ADD: "plus",
    MINUS: "minus",
    VISIBLE: "eye",
    INVISIBLE: "eye-slash",
    LOGOUT: "sign-out-alt",
    REFRESH: "sync-alt",
    PROLONG: "plus-square",
    CALENDAR: "calendar",
    CALENDAR_ADD: "calendar-plus",
    CALENDAR_CHECK: "calendar-check",
    CALENDAR_DAYS: "calendar-days",
    LIST: "list",
    COLUMNS: "columns",
    PIE_CHART: "chart-pie",
    TABLE: "table",
    CONFIG: "cog",
    SHARE: "share-alt",
    SETTINGS: "sliders-h",
    PALETTE: "palette",
    PEN_FANCY: "pen-fancy",
    CODE: "code",
    LOGS: "file-alt",
    COMMENT: "comment-alt-lines",
    COMMENTS: "comments",
    TITLE: "comment",
    ID_CARD: "id-card",
    ADD_USER: "user-friends",
    USER_SLASH: "user-slash",
    DURATION: "hourglass-start",
    LINK: "link",
    LINK_EXTERNAL: "external-link",
    CHAIR: "chair",
    TIMEZONE: "globe",
    VIEW_REPORT: "file-chart-line",
    ROWS: "align-justify",
    USER: "user",
    USERS: "users",
    SQUARE_FULL: "square-full",
    PLAY: "play",
    POWER_OFF: "power-off",
    EDIT_DATE: "calendar-lines-pen",
    PRIVATE_NOTE: "calendar-lines-pen",
    MEETING_ID: "list-ol",
    RESCHEDULE: "reply",
    BELL: "bell",
    SENT: "paper-plane",
    LOADING: "spinner",
    SETTINGS_TOGGLE: "arrow-to-right",
    SEARCH: "search",
    CIRCLE_CHECK: "circle-check",
    CODE_MERGE: "code-merge",

    // boolean
    SAVE: "check",
    ENABLE: "check",
    APPROVE: "check",
    CONFIRM: "check",
    ACCEPT: "check",
    ACTIVE: "check-square",
    YES: "check",
    CANCEL: "times",
    NO: "times",

    STATUS: {
        ACTIVE: "check",
        PENDING: "clock",
        CANCELED: "times",
        ERROR: "exclamation-triangle",
        ERROR_CIRCLE: "exclamation-circle",
        BLOCKED: "ban",
        NEW: "plus",
        ENABLE: "power-off",
    },

    INVOICE_DOWNLOAD: "file-download",
    REPORT: "line-columns", //"file-chart-line" ?
    POS: "store",
    REPORT_DOWNLOAD: 'download',

    ITEM: {
        SERVICE: "concierge-bell",
        PROVIDER: "id-card-alt", // "user-tie", //TODO provider vs client vs user?
        STATUS: "square-check",
        BOOKING: "calendar-check", //TODO
        CLIENT: "user",
        USER: "user-tie",
        INVOICE: "file-alt",
        NOTE: "sticky-note",
        GIFT_CARD: "gift-card",
        ONLINE_MEETING: "video-plus", // "video"? "camera-home"?

        DATE: "calendar",
        EMAIL: "envelope",
        SMS: "comment-alt",
        PHONE: "phone",
        TAX: "tags",

        NEW_FEATURE: "plus-square",
        NEW_NEWS: "file-lines",
    },

    NAVIGATE: {
        BACK: "chevron-left",
        FORWARD: "chevron-right",
        PREV: 'arrow-left-long',
        NEXT: 'arrow-right-long',
    }
}